import { render, staticRenderFns } from "./MypacksCommonTitle.vue?vue&type=template&id=244fd4a0&"
import script from "./MypacksCommonTitle.vue?vue&type=script&lang=js&"
export * from "./MypacksCommonTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports